import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import AgentNotification from 'models/agent_notification';
import connect from 'components/lib/connect';
import { Item, Text, Timestamp } from './shared_notification';
import MarkAgentNotificationAsRead from 'actions/agent_notifications/mark_agent_notification_as_read';
import NavigateToItem from 'actions/conversation_item/navigate_to_item';
import { useExecuteAction } from 'components/hooks/connect_hooks';

const Type = AgentNotification.Type;
const RESPONSE_TYPES = [Type.ASSIGNED_TASK_RESPONSE_RECEIVED, Type.FOLLOWED_TASK_RESPONSE_RECEIVED];
const REPLIED_TYPES = [Type.ASSIGNED_TASK_REPLIED, Type.FOLLOWED_TASK_REPLIED];

export function isTaskThreadNotification(notification) {
  return RESPONSE_TYPES.includes(notification.type) || REPLIED_TYPES.includes(notification.type);
}

function TaskThreadItem({ agent, notification }) {
  const { t } = useTranslation();
  const executeAction = useExecuteAction();

  const onClick = () => {
    executeAction(MarkAgentNotificationAsRead, { id: notification.id });
    executeAction(NavigateToItem, { customerId: notification.content.customerId, itemId: notification.content.taskId });
  };

  const objectText =
    notification.type === Type.ASSIGNED_TASK_RESPONSE_RECEIVED || notification.type === Type.ASSIGNED_TASK_REPLIED
      ? t('assigned to you')
      : t('you follow');

  let text;
  if (RESPONSE_TYPES.includes(notification.type)) {
    // A third party has no profile here; its initiator id is its email address, which is what the
    // agent knows it by.
    const sender = notification.initiator?.id || t('Someone');
    text = t('{{sender}} replied on a task {{objectText}}', { sender, objectText });
  } else {
    const agentName = agent ? agent.getDisplayName() : t('An agent');
    text = t('{{agentName}} replied to the third party on a task {{objectText}}', { agentName, objectText });
  }

  return (
    <Item onClick={onClick}>
      <Text hasRead={notification.hasRead()}>{text}</Text>
      <Timestamp timestamp={notification.createdAt} />
    </Item>
  );
}

TaskThreadItem.propTypes = {
  agent: PropTypes.object,
  notification: PropTypes.instanceOf(AgentNotification).isRequired,
};

function mapStateToProps({ getProvider }, { notification }) {
  return {
    agent: getProvider('agents').findBy({ id: notification.initiator?.id }),
  };
}

export default connect(mapStateToProps)(TaskThreadItem);
